(($) => {


    // SVG - Vivus animations init (desktop only)
    let anim = {
        type: 'delayed',
        duration: 200
    }

    $('.HowItWorks-items').each(function () {
        new Vivus('js-HowItWorks-anim1', anim)
        new Vivus('js-HowItWorks-anim2', anim)
        new Vivus('js-HowItWorks-anim3', anim)
        new Vivus('js-HowItWorks-anim4', anim)
    })


    // Carousel (mobile only)
    $('.js-HowItWorks-carousel').flickity({
        wrapAround: true,
        groupCells: 1,
        autoPlay: 4000,
        lazyLoad: 1,
        watchCSS: true,
        dragTreshold: 25,
        cellAlign: 'center',
        pageDots: true
    })


})(jQuery)
